export default __webpack_public_path__ + "static/media/500.7ce59e5f.png";